import { render, staticRenderFns } from "./ModalCidadao.vue?vue&type=template&id=fd176dd2&scoped=true"
import script from "./ModalCidadao.vue?vue&type=script&lang=js"
export * from "./ModalCidadao.vue?vue&type=script&lang=js"
import style0 from "./ModalCidadao.vue?vue&type=style&index=0&id=fd176dd2&prod&scoped=true&lang=scss"
import style1 from "./ModalCidadao.vue?vue&type=style&index=1&id=fd176dd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd176dd2",
  null
  
)

export default component.exports